import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {TagInputModule} from 'ng2-tag-input';
import {MultiselectorComponent} from './multiselector.component';

/**
 * Created by Arturo Campos on 08/02/17.
 */
@NgModule({
    imports: [CommonModule, FormsModule, TagInputModule],
    declarations: [MultiselectorComponent],
    exports: [MultiselectorComponent],
})
export class MultiselectorModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forms/controls/multiselector/multiselector.module.ts